import { networkAtom } from "@/atoms/settings"
import { Box, Menu, MenuItem } from "@mui/material"
import { BlockchainNetwork } from "@renec-foundation/relend-adapter"
import { useAtomValue } from "jotai"
import React, { useCallback, useState } from "react"

import navbarLinks from "@/constants/navbarLinks"
import useTrans from "@/hooks/useTrans"
import LendingMenuItem from "../desktop/MenuItem"

type MenuDocumentProps = {
  prefixMenuId?: string
}

const MenuDocument = ({ prefixMenuId = "header" }: MenuDocumentProps) => {
  const trans = useTrans()
  const [anchorEl, setAnchorEl] = useState<Element | null>(null)
  const handleDocsMenuHover = useCallback(
    (event: React.SyntheticEvent) => {
      if (anchorEl !== event.currentTarget) {
        setAnchorEl(event.currentTarget)
      }
    },
    [anchorEl],
  )
  const network = useAtomValue(networkAtom)
  const isRenecNetwork = network === BlockchainNetwork.RENEC

  const handleDocsMenuClose = useCallback(() => {
    setAnchorEl(null)
  }, [])

  return (
    <Box onMouseEnter={handleDocsMenuHover} onClick={handleDocsMenuHover} data-testid={`${prefixMenuId}-menu-more`}>
      <LendingMenuItem href='#' label={trans.header.docs} dataTestId='menu-docs' isActive={false} />
      <Menu
        id='menu-docs'
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleDocsMenuClose}
        disableScrollLock={true}
        disableAutoFocusItem
      >
        {isRenecNetwork && (
          <MenuItem onClick={handleDocsMenuClose}>
            <LendingMenuItem
              href={navbarLinks.liquidations}
              label={trans.header.liquidations}
              dataTestId={`${prefixMenuId}-menu-docs-liquidations`}
              isActive={false}
              target='_blank'
            />
          </MenuItem>
        )}
        <MenuItem onClick={handleDocsMenuClose}>
          <LendingMenuItem
            href={trans.header.tokenomic_link}
            label={trans.header.tokenomic}
            dataTestId={`${prefixMenuId}-menu-docs-tokenomic`}
            isActive={false}
            target='_blank'
          />
        </MenuItem>
        <MenuItem onClick={handleDocsMenuClose}>
          <LendingMenuItem
            href={trans.header.audit_link}
            label={trans.header.audits}
            dataTestId={`${prefixMenuId}-menu-docs-audit`}
            isActive={false}
            target='_blank'
          />
        </MenuItem>
      </Menu>
    </Box>
  )
}

export default MenuDocument
